import request from '../utils/request';

// 陪逛服务售后 API
export const accompanyShoppingAfterSaleApi = {
  // 获取售后服务列表
  getAfterSaleList: (params) => request.get('/accompany-shopping-after-sale/list', { params }),
  
  // 获取售后服务详情
  getAfterSaleDetail: (id) => request.get(`/accompany-shopping-after-sale/${id}`),
  
  // 处理售后服务
  handleAfterSale: (id, data) => request.put(`/accompany-shopping-after-sale/${id}/handle`, data),
  
  // 更新售后服务状态
  updateAfterSaleStatus: (id, data) => request.put(`/accompany-shopping-after-sale/${id}/status`, data),
  
  // 拒绝售后服务
  rejectAfterSale: (id, data) => request.put(`/accompany-shopping-after-sale/${id}/reject`, data),
  
  // 完成售后服务
  completeAfterSale: (id) => request.put(`/accompany-shopping-after-sale/${id}/complete`),
  
  // 导出售后服务列表
  exportAfterSales: (params) => request.get('/accompany-shopping-after-sale/export', { params, responseType: 'blob' })
}; 